import styled from 'styled-components';

export const Interpunct = styled.div`
  margin: 0 6px;
  &::after {
    content: '•'
  }
  &.inline {
    display: inline-block;
  }
`;
